import { render } from "./SliderDesktop.vue?vue&type=template&id=6a6398e2&scoped=true"
import script from "./SliderDesktop.vue?vue&type=script&lang=js"
export * from "./SliderDesktop.vue?vue&type=script&lang=js"

import "./SliderDesktop.vue?vue&type=style&index=0&id=6a6398e2&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6398e2"]])

export default __exports__